export default {
    page(page){
        return {
            update: `/account/page/${page.id}`,
        }
    },
    section(course, section = {id : null}) {
        return {
            index: `/home/courses/${course.id}/sections`,
            delete: `/home/courses/${course.id}/sections/${section.id}`,
            update: `/home/courses/${course.id}/sections/${section.id}`,
            store: `/home/courses/${course.id}/sections`,
            order: `/home/courses/${course.id}/sections/order`,
        }
    },
    lecture(course, section, lecture = {id: null}) {
        return {
            delete: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}`,
            create: `/home/courses/${course.id}/sections/${section.id}/lectures/create`,
            store: `/home/courses/${course.id}/sections/${section.id}/lectures`,
            edit: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}`,
            update: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}`,
            order: `/home/courses/${course.id}/sections/${section.id}/lectures/order`,
            createVideo: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/create-video`,
            createPdf: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/create-pdf`,
        }
    },
    component(course, section, lecture, component = {id: null}) {
        return {
            order: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/components/order`,
            store: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/components`,
            delete: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/components/${component.id}`,
            update: `/home/courses/${course.id}/sections/${section.id}/lectures/${lecture.id}/components/${component.id}`,
        }
    },
    image(url = false) {
        if (!url) {
            return false
        }
        return `https://djceg34j53tq.cloudfront.net/${url}`
    },
    images() {
        return {
            initiateUpload: `/home/images/create`,
            delete: `/home/images/delete`,
        }
    },
    block(subpage, block = {id: null}) {
        return {
            update: `/home/subpages/${subpage.id}/blocks/${block.id}`,
            delete: `/home/subpages/${subpage.id}/blocks/${block.id}`,
            store: `/home/subpages/${subpage.id}/blocks`,
            order: `/home/subpages/${subpage.id}/blocks/order`,
        }
    },
}